import cn from 'classnames'
import React, { ComponentProps } from 'react'

type ShieldIconSvgProps = ComponentProps<'svg'>

export default function ShieldIconSvg(props: ShieldIconSvgProps) {
  const { className = '', ...rest } = props

  return (
    <svg
      className={cn('ShieldIconSVG', className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9584 14.876H15.4535C15.3201 14.876 15.212 14.9832 15.212 15.1154V15.4505C15.212 15.5827 15.3201 15.6899 15.4535 15.6899H21.9584C22.0919 15.6899 22.2 15.5827 22.2 15.4505V15.1154C22.2 14.9832 22.0919 14.876 21.9584 14.876Z"
        fill="#EAEBF1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.74481 11.1074H1.2416C1.10818 11.1074 1.00002 11.2146 1.00002 11.3468V11.6819C1.00002 11.8142 1.10818 11.9213 1.2416 11.9213H5.74481C5.87823 11.9213 5.98639 11.8142 5.98639 11.6819V11.3468C5.98639 11.2146 5.87823 11.1074 5.74481 11.1074Z"
        fill="#EAEBF1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.3579 7.53711H18.8564C18.723 7.53711 18.6148 7.64429 18.6148 7.77649V8.11163C18.6148 8.24384 18.723 8.35102 18.8564 8.35102H21.3579C21.4913 8.35102 21.5995 8.24384 21.5995 8.11163V7.77649C21.5995 7.64429 21.4913 7.53711 21.3579 7.53711Z"
        fill="#EAEBF1"
      />
      <g filter="url(#filter0_d_1717_10015)">
        <path
          d="M11.4212 2.23909C11.6054 2.16247 11.8125 2.16251 11.9968 2.23909L19.353 5.29704C19.6332 5.41353 19.8158 5.68739 19.8158 5.99113V9.70849C19.8158 14.8271 16.7258 19.4313 11.9927 21.3656C11.8108 21.4399 11.6071 21.4399 11.4253 21.3656C6.69211 19.4313 3.60217 14.827 3.60217 9.70849V5.99113C3.60217 5.68739 3.7848 5.41353 4.06497 5.29704L11.4212 2.23909Z"
          fill="#4489F9"
        />
        <path
          d="M11.305 1.96491L3.94884 5.02284L3.90367 5.04296C3.53306 5.22126 3.30194 5.58846 3.30194 5.99129V9.70864L3.30287 9.86382C3.3654 15.0447 6.5165 19.6815 11.3109 21.6408C11.566 21.7451 11.852 21.745 12.1071 21.6408C16.9531 19.6604 20.1161 14.9473 20.1161 9.70864V5.99129L20.1148 5.94203C20.0926 5.53264 19.8424 5.17799 19.4692 5.02284L12.113 1.96489L12.0528 1.94201C11.8093 1.85787 11.5431 1.86587 11.305 1.96491ZM11.8533 2.50332L11.8893 2.51703L19.2369 5.57155C19.3971 5.63815 19.5054 5.79165 19.5149 5.96614L19.5157 5.99932V9.70864C19.5157 14.707 16.4986 19.2025 11.8782 21.0907C11.7697 21.135 11.6483 21.135 11.5398 21.0907C6.96857 19.2226 3.96299 14.7999 3.90335 9.85849L3.90244 9.70687V5.99129C3.90244 5.81592 4.00263 5.65675 4.15862 5.58165L4.18873 5.56828L11.5373 2.51361C11.6274 2.47617 11.7266 2.46933 11.8202 2.49339L11.8533 2.50332Z"
          fill="#3475F2"
        />
      </g>
      <g filter="url(#filter1_d_1717_10015)">
        <path
          d="M11.7466 5.98383C12.0858 5.98383 12.3666 6.23152 12.4149 6.55433L12.4222 6.65325L12.4222 13.0572C12.4222 13.4269 12.1197 13.7266 11.7466 13.7266C11.4075 13.7266 11.1267 13.479 11.0784 13.1561L11.0711 13.0572L11.0711 6.65325C11.0711 6.28354 11.3735 5.98383 11.7466 5.98383Z"
          fill="#F6F7FB"
        />
        <path
          d="M11.754 14.9023C12.0932 14.9023 12.374 15.15 12.4223 15.4728L12.4296 15.5717L12.4296 15.9492C12.4296 16.319 12.1271 16.6187 11.754 16.6187C11.4148 16.6187 11.134 16.371 11.0858 16.0482L11.0785 15.9492L11.0785 15.5717C11.0785 15.202 11.3809 14.9023 11.754 14.9023Z"
          fill="#F6F7FB"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_1717_10015"
          x="-6.69806"
          y="-4.11572"
          width="36.8141"
          height="39.8345"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1717_10015"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1717_10015"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_1717_10015"
          x="1.07104"
          y="-0.0161133"
          width="21.3586"
          height="30.6348"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1717_10015"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1717_10015"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
